import React from "react";
import { Stack, Typography, Box } from "@mui/material";

import { LaborSolutionsLogo } from "components/logos/labor-solutions-logo";
import { useTranslation } from "hooks/use-translation";

export function SidebarFooter() {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={3}
      sx={{ height: "70px", pl: 3, py: 1.375 }}
    >
      <Box display="inline-flex">
        <LaborSolutionsLogo size={32} />
      </Box>
      <Typography variant="body2" color="text.primary" fontWeight={700}>
        {t("DIC_SIDE_BAR_FOOTER_BY_LABOR_SOLUTIONS")}
      </Typography>
    </Stack>
  );
}
